"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETH = void 0;
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
exports.FETH = [
    {
        inputs: [
            {
                internalType: 'address payable',
                name: '_foundationMarket',
                type: 'address',
            },
            {
                internalType: 'address payable',
                name: '_foundationDropMarket',
                type: 'address',
            },
            {
                internalType: 'address payable',
                name: '_foundationMultiTokenDropMarket',
                type: 'address',
            },
            { internalType: 'uint256', name: '_lockupDuration', type: 'uint256' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'FETH_Cannot_Deposit_For_Lockup_With_Address_Zero',
        type: 'error',
    },
    { inputs: [], name: 'FETH_Cannot_Deposit_To_Address_Zero', type: 'error' },
    { inputs: [], name: 'FETH_Cannot_Deposit_To_FETH', type: 'error' },
    { inputs: [], name: 'FETH_Cannot_Withdraw_To_Address_Zero', type: 'error' },
    { inputs: [], name: 'FETH_Cannot_Withdraw_To_FETH', type: 'error' },
    { inputs: [], name: 'FETH_Cannot_Withdraw_To_Market', type: 'error' },
    { inputs: [], name: 'FETH_Escrow_Expired', type: 'error' },
    { inputs: [], name: 'FETH_Escrow_Not_Found', type: 'error' },
    { inputs: [], name: 'FETH_Expiration_Too_Far_In_Future', type: 'error' },
    {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'FETH_Insufficient_Allowance',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'FETH_Insufficient_Available_Funds',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'FETH_Insufficient_Escrow',
        type: 'error',
    },
    { inputs: [], name: 'FETH_Invalid_Lockup_Duration', type: 'error' },
    { inputs: [], name: 'FETH_Market_Must_Be_A_Contract', type: 'error' },
    { inputs: [], name: 'FETH_Must_Deposit_Non_Zero_Amount', type: 'error' },
    { inputs: [], name: 'FETH_Must_Lockup_Non_Zero_Amount', type: 'error' },
    { inputs: [], name: 'FETH_No_Funds_To_Withdraw', type: 'error' },
    { inputs: [], name: 'FETH_Only_FND_Market_Allowed', type: 'error' },
    { inputs: [], name: 'FETH_Too_Much_ETH_Provided', type: 'error' },
    {
        inputs: [],
        name: 'FETH_Transfer_To_Address_Zero_Not_Allowed',
        type: 'error',
    },
    { inputs: [], name: 'FETH_Transfer_To_FETH_Not_Allowed', type: 'error' },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'expiration',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'valueDeposited',
                type: 'uint256',
            },
        ],
        name: 'BalanceLocked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'expiration',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'BalanceUnlocked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'ETHWithdrawn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        inputs: [
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'address', name: 'operator', type: 'address' },
        ],
        name: 'allowance',
        outputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'spender', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [{ internalType: 'bool', name: 'success', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: 'balance', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'deposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'depositFor',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getFoundationDropMarket',
        outputs: [{ internalType: 'address', name: 'market', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getFoundationMarket',
        outputs: [{ internalType: 'address', name: 'market', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getFoundationMultiTokenDropMarket',
        outputs: [{ internalType: 'address', name: 'market', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'getLockups',
        outputs: [
            { internalType: 'uint256[]', name: 'expiries', type: 'uint256[]' },
            { internalType: 'uint256[]', name: 'amounts', type: 'uint256[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'unlockFrom', type: 'address' },
            { internalType: 'uint256', name: 'unlockExpiration', type: 'uint256' },
            { internalType: 'uint256', name: 'unlockAmount', type: 'uint256' },
            { internalType: 'address', name: 'lockupFor', type: 'address' },
            { internalType: 'uint256', name: 'lockupAmount', type: 'uint256' },
        ],
        name: 'marketChangeLockup',
        outputs: [{ internalType: 'uint256', name: 'expiration', type: 'uint256' }],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'marketLockupFor',
        outputs: [{ internalType: 'uint256', name: 'expiration', type: 'uint256' }],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'uint256', name: 'expiration', type: 'uint256' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'marketUnlockFor',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'marketWithdrawFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'account', type: 'address' },
            { internalType: 'uint256', name: 'expiration', type: 'uint256' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'marketWithdrawLocked',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'totalBalanceOf',
        outputs: [{ internalType: 'uint256', name: 'balance', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: 'supply', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: 'success', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [{ internalType: 'bool', name: 'success', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawAvailableBalance',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address payable', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'withdrawFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    { stateMutability: 'payable', type: 'receive' },
];
//# sourceMappingURL=FETH.generated.js.map